import { useMemo, Dispatch, SetStateAction, useState } from 'react'
import { HStack, Select, Text, VStack } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { FilterPeriod } from '../../types'
import { periodOptions } from '../../constants'
import { MonthPicker } from '@/components/MonthPicker'

export type PeriodFilterProps = {
  setPeriod: Dispatch<SetStateAction<FilterPeriod>>
  customPeriod: string
  setCustomPeriod: Dispatch<SetStateAction<string>>
}

export const PeriodFilter = (props: PeriodFilterProps) => {
  const { setPeriod, customPeriod, setCustomPeriod } = props
  const [isCustomPeriod, setIsCustomPeriod] = useState(false)

  const { t } = useTranslation('domainConsent')

  const formatPeriodOptions = useMemo(() => {
    return periodOptions.map(({ label, value }) => (
      <option value={value} key={`period-${value}`}>
        {t(label)}
      </option>
    ))
  }, [periodOptions, t])

  return (
    <HStack spacing="4" alignItems="flex-start">
      <VStack alignItems="flex-start">
        <Text fontWeight="medium" color="gray.900" h={6}>
          {t('filter.period')}
        </Text>
        <Select
          size="sm"
          onChange={(e) => {
            if ((e.currentTarget.value as FilterPeriod) === 'custom') {
              setIsCustomPeriod(true)
            } else {
              setIsCustomPeriod(false)
              setPeriod(e.currentTarget.value as FilterPeriod)
              setCustomPeriod('')
            }
          }}
          sx={{ w: '240px' }}
          id="consent-action-select"
        >
          {formatPeriodOptions}
        </Select>
      </VStack>

      {isCustomPeriod && (
        <VStack alignItems="flex-start">
          <Text fontWeight="medium" color="gray.900" h={6}>
            {t('filter.custom')}
          </Text>
          <MonthPicker
            selected={customPeriod}
            onChange={(e) => {
              setPeriod('custom')
              setCustomPeriod(`${e.getMonth() + 1}/${e.getFullYear()}`)
            }}
            size="sm"
          />
        </VStack>
      )}
    </HStack>
  )
}
